import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-epson-powered',
  templateUrl: './epson-powered.component.html',
  styleUrls: ['./epson-powered.component.scss'],
})
/**
 * Powered By Epson!
 */
export class EpsonPoweredComponent {
  private _small: boolean = false;

  /**
   * If text is smaller or not
   */
  @Input()
  get small(): boolean {
    return this._small;
  }

  /**
   * Sets anchor as small
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set small(value: any) {
    this._small = coerceBooleanProperty(value);
  }
}
